/* =========================================================
   RC SHARE — JS isolé (update-safe)
   - Delegation click on [data-rc-share-trigger]
   - Primary: Web Share API
   - Fallback: RC Pop-in Hub preset "share" (via event rc:popin:open)
   - Ultimate fallback: open first intent in new window
   ========================================================= */

(function () {
  'use strict';

  var SELECTOR_TRIGGER = '[data-rc-share-trigger]';
  var SELECTOR_PAYLOAD = 'script[type="application/json"][data-rc-share-payload]';

  function debugLog() {
    if (window.RC_DEBUG === true && window.console && console.log) {
      console.log.apply(console, arguments);
    }
  }

  function escapeHtml(str) {
    str = (str == null) ? '' : String(str);
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeJsonParse(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  // Source "global" (si un jour tu remets un payload global)
  // Sinon: on pioche le payload de la section .rc-share (config exploitant)
  function getGlobalShareConfig() {
    var sGlobal = document.querySelector('script[type="application/json"][data-rc-share-global]');
    if (sGlobal) return safeJsonParse(sGlobal.textContent || '');

    var scripts = document.querySelectorAll('.rc-share script[type="application/json"][data-rc-share-payload]');
    if (!scripts || !scripts.length) return null;

    // On préfère celui qui contient des icônes custom (si présent)
    for (var i = 0; i < scripts.length; i++) {
      var obj = safeJsonParse(scripts[i].textContent || '');
      if (!obj) continue;
      if (obj.icons && typeof obj.icons === 'object' && Object.keys(obj.icons).length > 0) return obj;
    }

    // Sinon, premier payload valide
    for (var j = 0; j < scripts.length; j++) {
      var obj2 = safeJsonParse(scripts[j].textContent || '');
      if (obj2) return obj2;
    }

    return null;
  }

  function getClosestPayload(triggerEl) {
    if (!triggerEl) return null;

    // 1) sibling direct next
    var next = triggerEl.nextElementSibling;
    if (next && next.matches && next.matches(SELECTOR_PAYLOAD)) {
      return safeJsonParse(next.textContent || '');
    }

    // 2) within same parent
    var parent = triggerEl.parentElement;
    if (parent) {
      var script = parent.querySelector(SELECTOR_PAYLOAD);
      if (script) return safeJsonParse(script.textContent || '');
    }

    // 3) closest container
    var container = triggerEl.closest('.rc-share, [data-section-id], article, main, body');
    if (container) {
      var script2 = container.querySelector(SELECTOR_PAYLOAD);
      if (script2) return safeJsonParse(script2.textContent || '');
    }

    return null;
  }

  function normalizePayload(raw, triggerEl) {
    raw = raw || {};

    var g = getGlobalShareConfig();
    if (g) {
      // networks (global PRIORITY)
      if (Array.isArray(g.networks) && g.networks.length) raw.networks = g.networks;

      // labels
      raw.labels = (raw.labels && typeof raw.labels === 'object') ? raw.labels : {};
      if (g.labels && typeof g.labels === 'object') {
        Object.keys(g.labels).forEach(function (k) {
          if (g.labels[k]) raw.labels[k] = g.labels[k];
        });
      }

      // icons
      raw.icons = (raw.icons && typeof raw.icons === 'object') ? raw.icons : {};
      if (g.icons && typeof g.icons === 'object') {
        Object.keys(g.icons).forEach(function (k) {
          if (g.icons[k]) raw.icons[k] = g.icons[k];
        });
      }

      // misc
      if (raw.has_others_button == null && g.has_others_button != null) raw.has_others_button = g.has_others_button;
      if (!raw.icons_mode && g.icons_mode) raw.icons_mode = g.icons_mode;
      if (!raw.max_buttons && g.max_buttons) raw.max_buttons = g.max_buttons;

      // image (si ton global en fournit une un jour)
      if (!raw.image && g.image) raw.image = g.image;
    }

    var url = (raw.url && String(raw.url)) || window.location.href;
    var title = (raw.title && String(raw.title)) || document.title || '';
    var text = (raw.text && String(raw.text)) || '';

    raw.labels = (raw.labels && typeof raw.labels === 'object') ? raw.labels : {};
    raw.icons  = (raw.icons  && typeof raw.icons  === 'object') ? raw.icons  : {};

    var image = raw.image ? String(raw.image) : '';
    if (image && image.indexOf('//') === 0) image = 'https:' + image;

    var networks = Array.isArray(raw.networks) ? raw.networks.filter(Boolean) : [];

    var allowed = {
      whatsapp: true,
      facebook: true,
      x: true,
      email: true,
      sms: true,
      linkedin: true,
      telegram: true,
      messenger: true,
      pinterest: true
    };

    (function () {
      var out = [];

      function pushKey(k) {
        if (!k) return;
        k = String(k).toLowerCase().trim();
        if (!allowed[k]) return;
        if (out.indexOf(k) !== -1) return;
        out.push(k);
      }

      networks.forEach(function (item) {
        if (item == null) return;

        var s = String(item).toLowerCase().replace(/\s+/g, '');

        if (s.indexOf(',') !== -1) {
          s.split(',').forEach(pushKey);
          return;
        }

        var matches = s.match(/whatsapp|facebook|linkedin|telegram|messenger|pinterest|email|sms|x/g);
        if (matches && matches.length) {
          matches.forEach(pushKey);
          return;
        }

        pushKey(s);
      });

      networks = out;
    })();

    var maxButtons = Number(raw.max_buttons || 4) || 4;
    var hasOthers = raw.has_others_button !== false; // default true
    var iconsMode = raw.icons_mode || 'sprite';

    networks = networks.slice(0, maxButtons);

    var popinTarget = (triggerEl && triggerEl.getAttribute('data-rc-popin-target')) || '#rc-popin-global';
    var popinPreset = (triggerEl && triggerEl.getAttribute('data-rc-popin-preset')) || 'share';

    return {
      title: title,
      text: text,
      url: url,
      image: image,
      networks: networks,
      labels: raw.labels,
      icons: raw.icons,
      maxButtons: maxButtons,
      hasOthers: hasOthers,
      iconsMode: iconsMode,
      popinTarget: popinTarget,
      popinPreset: popinPreset
    };
  }

  function canWebShare(payload) {
    if (!navigator.share) return false;

    if (navigator.canShare) {
      try {
        return navigator.canShare({ url: payload.url || window.location.href });
      } catch (e) {
        return true;
      }
    }
    return true;
  }

  async function tryWebShare(payload) {
    if (!canWebShare(payload)) return { ok: false, reason: 'unsupported' };

    try {
      await navigator.share({
        title: payload.title || '',
        text: payload.text || '',
        url: payload.url || ''
      });
      return { ok: true };
    } catch (err) {
      debugLog('[rc-share] navigator.share error:', err);
      return { ok: false, reason: (err && err.name) ? err.name : 'error' };
    }
  }

  function encode(str) {
    return encodeURIComponent(str == null ? '' : String(str));
  }

  function buildIntentUrl(networkKey, payload) {
    var url = payload.url || window.location.href;
    var text = payload.text ? (payload.text + ' ') : '';
    var title = payload.title || '';

    switch (networkKey) {
      case 'whatsapp':  return 'https://wa.me/?text=' + encode(text + url);
      case 'facebook':  return 'https://www.facebook.com/sharer/sharer.php?u=' + encode(url);
      case 'x':         return 'https://twitter.com/intent/tweet?text=' + encode(text || title) + '&url=' + encode(url);
      case 'linkedin':  return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encode(url);
      case 'telegram':  return 'https://t.me/share/url?url=' + encode(url) + '&text=' + encode(text || title);
      case 'messenger': return 'https://www.facebook.com/dialog/send?link=' + encode(url);
      case 'pinterest': return 'https://www.pinterest.com/pin/create/button/?url=' + encode(url) + '&description=' + encode(text || title);
      case 'sms': {
        var body = (text ? text : '') + url;
        return 'sms:?&body=' + encode(body);
      }
      case 'email': {
        var subject = title || 'Partage';
        var emailBody = (text ? text + '\n\n' : '') + url;
        return 'mailto:?subject=' + encode(subject) + '&body=' + encode(emailBody);
      }
      default:
        return '';
    }
  }

  function getNetworkMeta(networkKey) {
    switch (networkKey) {
      case 'whatsapp': return { label: 'WhatsApp',  icon: 'rc-icon-whatsapp' };
      case 'facebook': return { label: 'Facebook',  icon: 'rc-icon-facebook' };
      case 'x':        return { label: 'X',         icon: 'rc-icon-x' };
      case 'email':    return { label: 'Email',     icon: 'rc-icon-email' };
      case 'sms':      return { label: 'SMS',       icon: 'rc-icon-sms' };
      case 'linkedin': return { label: 'LinkedIn',  icon: 'rc-icon-linkedin' };
      case 'telegram': return { label: 'Telegram',  icon: 'rc-icon-telegram' };
      case 'messenger':return { label: 'Messenger', icon: 'rc-icon-messenger' };
      case 'pinterest':return { label: 'Pinterest', icon: 'rc-icon-pinterest' };
      default:         return { label: networkKey,  icon: 'rc-icon-share' };
    }
  }

  function truncateUrl(u) {
    if (!u) return '';
    try {
      var x = new URL(u, window.location.href);
      var clean = x.host + x.pathname;
      if (clean.length > 46) clean = clean.slice(0, 43) + '…';
      return clean;
    } catch (e) {
      var s = String(u);
      return s.length > 46 ? s.slice(0, 43) + '…' : s;
    }
  }

  function buildSharePanelHtml(payload) {
    var networks = Array.isArray(payload.networks) ? payload.networks.slice(0, payload.maxButtons) : [];
    var hasAny = networks.length > 0;

    var html = '';
    html += '<div class="rc-share__panel" data-rc-share-panel>';
    html +=   '<div class="rc-share__layout">';

    if (payload.image) {
      html += '<div class="rc-share__media" aria-hidden="true">';
      html +=   '<img class="rc-share__media-img" src="' + escapeHtml(payload.image) + '" alt="" loading="lazy" />';
      html += '</div>';
    }

    html +=     '<div class="rc-share__body">';
    html +=       '<h3 class="rc-share__panel-title">Partager</h3>';

    if (!hasAny && payload.hasOthers !== true) {
      html += '<p class="rc-share__muted">Aucune option de partage n’est configurée.</p>';
      html +=     '</div></div></div>';
      return html;
    }

    html += '<div class="rc-share__grid" role="list">';

    networks.forEach(function (key) {
      var meta = getNetworkMeta(key);
      var intent = buildIntentUrl(key, payload);
      if (!intent) return;

      var label = (payload.labels && payload.labels[key]) ? String(payload.labels[key]) : meta.label;

      var iconUrl = (payload.icons && payload.icons[key]) ? String(payload.icons[key]) : null;
      if (iconUrl && iconUrl.indexOf('//') === 0) iconUrl = 'https:' + iconUrl;

      var iconHtml = iconUrl
        ? '<img class="rc-share__icon-img" src="' + escapeHtml(iconUrl) + '" alt="" loading="lazy" />'
        : '<svg class="rc-share__icon" aria-hidden="true" focusable="false"><use href="#' + meta.icon + '"></use></svg>';

      html += '<a class="rc-share__option" role="listitem" href="' + escapeHtml(intent) + '" target="_blank" rel="noopener noreferrer" data-rc-share-intent="' + escapeHtml(key) + '" aria-label="Partager via ' + escapeHtml(label) + '">';
      html +=   iconHtml;
      html +=   '<span>' + escapeHtml(label) + '</span>';
      html += '</a>';
    });

    if (payload.hasOthers === true && canWebShare(payload)) {
      html += '<button type="button" class="rc-share__option rc-share__option--share" data-rc-share-others aria-label="Partager" role="listitem">';
      html +=   '<svg class="rc-share__icon" aria-hidden="true" focusable="false"><use href="#rc-icon-share"></use></svg>';
      html +=   '<span>Partager</span>';
      html += '</button>';
    }

    html += '</div>'; // grid

    // Copy row
    html += '<div class="rc-share__copy">';
    html +=   '<div class="rc-share__copy-url" aria-label="Lien">' + escapeHtml(truncateUrl(payload.url || window.location.href)) + '</div>';
    html +=   '<button type="button" class="rc-share__copy-btn" data-rc-share-copy>Copier</button>';
    html += '</div>';

    html +=     '</div>'; // body
    html +=   '</div>';   // layout
    html += '</div>';     // panel
    return html;
  }

  function findPopinRoot(targetSelector) {
    if (!targetSelector) return null;
    try { return document.querySelector(targetSelector); } catch (e) { return null; }
  }

  function findPopinContentZone(popinRoot) {
    if (!popinRoot) return null;

    var zone = popinRoot.querySelector('[data-rc-popin-content]');
    if (zone) return zone;

    zone = popinRoot.querySelector('.rc-popin__content, .rc-popin-content, .hdt-modal__content, .modal__content');
    return zone || null;
  }

  function openHubPopin(payload) {
    var popinRoot = findPopinRoot(payload.popinTarget);
    var contentZone = findPopinContentZone(popinRoot);

    if (!popinRoot || !contentZone) {
      return { ok: false, reason: 'hub_missing' };
    }

    // Open via hub contract
    try {
      var ev = new CustomEvent('rc:popin:open', {
        bubbles: true,
        detail: {
          target: payload.popinTarget,
          preset: payload.popinPreset,
          action: 'share'
        }
      });
      popinRoot.dispatchEvent(ev);
    } catch (e2) {
      debugLog('[rc-share] custom event failed:', e2);
    }

    // Inject AFTER open to avoid hub overwriting the content
    setTimeout(function () {
      contentZone.innerHTML = buildSharePanelHtml(payload);

      // Web Share button
      var othersBtn = contentZone.querySelector('[data-rc-share-others]');
      if (othersBtn) {
        othersBtn.addEventListener('click', function () {
          tryWebShare(payload);
        });
      }

      // Copy link
      var copyBtn = contentZone.querySelector('[data-rc-share-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var u = payload.url || window.location.href;

          function done(ok) {
            copyBtn.textContent = ok ? 'Copié ✓' : 'Erreur';
            setTimeout(function () { copyBtn.textContent = 'Copier'; }, 1200);
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(u).then(function () { done(true); }).catch(function () { done(false); });
            return;
          }

          try {
            var ta = document.createElement('textarea');
            ta.value = u;
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            var ok = document.execCommand('copy');
            document.body.removeChild(ta);
            done(!!ok);
          } catch (e) {
            done(false);
          }
        });
      }
    }, 0);

    return { ok: true, via: 'injection' };
  }

  function ultimateFallback(payload) {
    var networks = Array.isArray(payload.networks) ? payload.networks : [];
    for (var i = 0; i < networks.length; i++) {
      var u = buildIntentUrl(networks[i], payload);
      if (u) {
        window.open(u, '_blank', 'noopener,noreferrer');
        return true;
      }
    }
    return false;
  }

  function isMobileContext() {
    // Prefer viewport-based detection (more reliable than UA).
    // UX contract: mobile => native share first; desktop => branded pop-in first.
    try {
      return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
    } catch (e) {
      return false;
    }
  }

  async function handleTriggerClick(triggerEl) {
    var raw = getClosestPayload(triggerEl);
    var payload = normalizePayload(raw, triggerEl);

    // Primary (mobile only): Web Share
    // Desktop should always open the pop-in first; Web Share remains an explicit action inside the panel.
    if (isMobileContext()) {
      var shareResult = await tryWebShare(payload);
      if (shareResult.ok) return;
    }

    // Fallback: popin
    var hubRes = openHubPopin(payload);
    if (hubRes.ok) return;

    // Ultimate
    ultimateFallback(payload);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    var trigger = t.closest ? t.closest(SELECTOR_TRIGGER) : null;
    if (!trigger) return;

    e.preventDefault();
    handleTriggerClick(trigger);
  });
})();

